import Cookies from "js-cookie";
import { LOGIN_ACTION_FAILURE, LOGIN_ACTION_LOADING, LOGIN_ACTION_STATUS_RESET, LOGIN_ACTION_SUCCESS, LOGOUT_ACTION_LOADING, LOGOUT_ACTION_SUCCESS, SET_PLANT_NAME_AND_ROLE } from "./auth.types";
import {
  // AES,
  enc
} from "crypto-js";
import { jwtDecode } from "jwt-decode";
let current_user_cookie_bytes;
let current_user_decrypted_data = {};
const cookie_instance = Cookies.withAttributes({ secure: true });
try {
  // current_user_cookie_bytes = AES.decrypt(cookie_instance.get('current_user') || "", "qc_scheduler");
  current_user_cookie_bytes = jwtDecode(cookie_instance.get('current_user') || "", process.env.REACT_APP_JWT_SECRET_KEY);
  current_user_decrypted_data = JSON.parse(current_user_cookie_bytes.toString(enc.Utf8) || "{}");
  // console.log({ current_user_decrypted_data });
} catch (error) {
  console.log({ error });
  cookie_instance.remove("current_user");
  cookie_instance.remove("isAuth");
  cookie_instance.remove("token");
}
const initial_current_user = current_user_decrypted_data || {
  "data": {
    "auth_token": "",
    "refresh_token": ""
  },
  "user": {
    "_id": "",
    "name": "",
    "email": "",
    "password": "",
    "enabled": true,
    "email_validated": false,
    "ipAddress": "",
    "role": "admin",
    "client_id_enabled": [],
    "pwdExpired": false,
    "pwdExpires": "",
    selected_plant: null
  }
};

// console.log({ isAuth: JSON.parse(Cookies.get("isAuth") || "false") });

const isAuth = JSON.parse(Cookies.get("isAuth") || "false") && initial_current_user?.data?.auth_token ? true : false;

const init_auth_state = {
  isAuth,
  states: {
    loading: false,
    success: false,
    failure: false,
    error_message: ""
  },
  current_user: {
    ...initial_current_user
  },
  all_users: []
};

export const auth_reducer = (state = init_auth_state, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_ACTION_LOADING:
      // Handle LOGIN_ACTION_LOADING
      return {
        ...state,
        states: {
          ...state.states,
          loading: true,
          success: false,
          failure: false,
          error_message: ""
        }
      };
    case LOGIN_ACTION_SUCCESS:
      // Handle LOGIN_ACTION_SUCCESS
      if (payload && typeof payload !== "string") {
        const data = payload;
        return {
          ...state,
          current_user: {
            ...data,
            user: {
              ...data.user,
            }
          },
          isAuth: true,
          states: {
            success: true,
            loading: false,
            error_message: "",
            failure: false
          }
        };
      }
      return state;
    case LOGIN_ACTION_FAILURE:
      // Handle LOGIN_ACTION_FAILURE
      if (payload && typeof payload === "string") {
        const error_message = payload;
        return {
          ...state,
          isAuth: false,
          states: {
            failure: true,
            error_message,
            success: false,
            loading: false
          }
        };
      }
      return state;
    case LOGIN_ACTION_STATUS_RESET:
      return {
        ...state,
        states: {
          ...state.states,
          loading: false,
          success: false,
          error_message: "",
          failure: false
        }
      };
    case SET_PLANT_NAME_AND_ROLE: {
      const { selected_plant, role } = payload;
      return {
        ...state,
        current_user: {
          ...state.current_user,
          user: {
            ...state.current_user.user,
            selected_plant: selected_plant,
            role,
          }
        }
      };
    }
    case LOGOUT_ACTION_LOADING: {
      return {
        ...state,
        states: {
          ...state.states,
          loading: true,
        }
      };
    }
    case LOGOUT_ACTION_SUCCESS: {
      return {
        ...state,
        states: {
          ...state.states,
          loading: false
        },
        isAuth: false,
        current_user: {
          ...initial_current_user
        }
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};
